"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var History_1 = __importDefault(require("@src/History"));
var CodeEditor_1 = __importDefault(require("@src/components/CodeEditor"));
var CommonStore_1 = __importDefault(require("@src/stores/CommonStore"));
var react_redux_1 = require("react-redux");
var maps_1 = require("../maps");
var reduxStores_1 = __importDefault(require("@src/reduxStores"));
var MogamboConstants_1 = require("@src/constants/MogamboConstants");
var actions_1 = require("../../CodeNode/store/actions");
var _utils_1 = require("@src/actions/_utils");
var const_1 = require("@src/const");
var BotActions_1 = require("../../../actions/BotActions");
var api_1 = require("../store/api");
var utils_1 = require("../utils");
var CodeEditorContainer = function () {
    var _a, _b, _c, _d;
    var _e = react_redux_1.useSelector(maps_1.stateToProps), currentActionData = _e.currentActionData, currentAgentData = _e.currentAgentData, domainId = _e.domainId, envVariables = _e.envVariables;
    var setEnvVariables = maps_1.dispatchToProps(react_redux_1.useDispatch()).setEnvVariables;
    var domain = (((_a = CommonStore_1["default"].getMetaTags().domain) === null || _a === void 0 ? void 0 : _a.length) &&
        CommonStore_1["default"].getMetaTags().domain) ||
        JSON.parse(localStorage.getItem('ww_iva'));
    var navToAgent = function () {
        var _a;
        var fetchedDomainId = '';
        if (!domainId) {
            var domain_1 = (((_a = CommonStore_1["default"].getMetaTags().domain) === null || _a === void 0 ? void 0 : _a.length) &&
                CommonStore_1["default"].getMetaTags().domain) ||
                JSON.parse(localStorage.getItem('ww_iva'));
            fetchedDomainId = domain_1 === null || domain_1 === void 0 ? void 0 : domain_1.id;
        }
        History_1["default"].push("/ai-agents-project/" + (domainId !== null && domainId !== void 0 ? domainId : fetchedDomainId) + "/agent/" + currentAgentData.id);
    };
    var navToCodeSubMenu = function (edited, code) {
        if (edited) {
            BotActions_1.showConfirmationDialog({
                okTitle: 'Leave',
                cancelTitle: 'Keep Editing',
                title: 'Are you sure you want to leave?',
                message: "It looks like you're still working on this. You may lose the info you've entered so far if you leave now.",
                onOk: function () {
                    navToAgent();
                },
                onCancel: function () { },
                okActionType: 'danger',
            });
        }
        else {
            navToAgent();
        }
    };
    var handleRun = function (inputJson, cb) {
        var _a, _b, _c, _d;
        if (!((_b = (_a = currentActionData.action_details) === null || _a === void 0 ? void 0 : _a['0']) === null || _b === void 0 ? void 0 : _b.function_name)) {
            BotActions_1.createAlert('Code Run failed. Try saving again.', null, MogamboConstants_1.AlertTypes.NEGATIVE);
            if (cb)
                cb('Code run failed! Try closing and opening code editor again.');
            return;
        }
        actions_1.runCodeNodeData((_d = (_c = currentActionData.action_details) === null || _c === void 0 ? void 0 : _c['0']) === null || _d === void 0 ? void 0 : _d.function_name, inputJson, function (success, e) {
            if (e && cb) {
                cb(e);
            }
            if (success) {
                BotActions_1.createAlert('Code run completed!', null, MogamboConstants_1.AlertTypes.POSITIVE);
            }
            else {
                BotActions_1.createAlert('Code run failed!', null, MogamboConstants_1.AlertTypes.NEGATIVE);
            }
        });
    };
    var handleSave = function (code, cb) {
        var _a, _b;
        api_1.updateAction(currentAgentData.id, currentActionData.id, __assign(__assign({}, currentActionData), { action_details: __assign(__assign({}, currentActionData.action_details), { '0': __assign(__assign({}, ((_b = (_a = currentActionData.action_details) === null || _a === void 0 ? void 0 : _a['0']) !== null && _b !== void 0 ? _b : {})), { custom_code_block: code, custom_code_block_edited: true }) }) }))
            .then(function (response) {
            if (response.success) {
                cb(true);
                BotActions_1.createAlert('Code saved !', null, MogamboConstants_1.AlertTypes.POSITIVE);
            }
        })["catch"](function (e) {
            BotActions_1.createAlert(e, null, MogamboConstants_1.AlertTypes.NEGATIVE);
            cb(false);
        });
    };
    var onSaveWithVariables = function (variables, code, cb) {
        var _a, _b;
        if (cb === void 0) { cb = function (success) { }; }
        if (!_utils_1.userHasPermission(const_1.PERMISSION_LEVELS.MOGAMBO_ALL_EDIT)) {
            cb(false);
            _utils_1.permissionErrorAlert();
            return;
        }
        if (!_utils_1.userHasPermission(const_1.PERMISSION_LEVELS.EDIT_ENV_VARIABLES)) {
            BotActions_1.createAlert('Not Valid Permissions', null, MogamboConstants_1.AlertTypes.NEGATIVE);
            cb(false);
        }
        setEnvVariables(variables);
        Promise.all([
            api_1.updateAction(currentAgentData.id, currentActionData.id, __assign(__assign({}, currentActionData), { action_details: __assign(__assign({}, currentActionData.action_details), { '0': __assign(__assign({}, ((_b = (_a = currentActionData.action_details) === null || _a === void 0 ? void 0 : _a['0']) !== null && _b !== void 0 ? _b : {})), { custom_code_block: code, custom_code_block_edited: true }) }) })),
            utils_1.saveEnvVariablesForActions(domainId, variables),
        ])
            .then(function (res) {
            BotActions_1.createAlert('Successfully Saved!', null, MogamboConstants_1.AlertTypes.POSITIVE);
            cb(true);
        })["catch"](function (err) {
            BotActions_1.createAlert(err, null, MogamboConstants_1.AlertTypes.NEGATIVE);
            cb(false);
        });
    };
    return (react_1["default"].createElement(CodeEditor_1["default"], { id: currentActionData.id, navToMenu: function (edited, code) { return navToCodeSubMenu(edited, code); }, code: (_d = (_c = (_b = currentActionData.action_details) === null || _b === void 0 ? void 0 : _b['0']) === null || _c === void 0 ? void 0 : _c.custom_code_block) !== null && _d !== void 0 ? _d : '', envVariables: envVariables, inputJSON: JSON.stringify(currentActionData.input_json, null, 2), onSave: function (code, cb) {
            handleSave(code, cb);
        }, onRun: function (inputJSON, cb) {
            handleRun(inputJSON, cb);
        }, envVariablesEnabled: _utils_1.userHasPermission(const_1.PERMISSION_LEVELS.EDIT_ENV_VARIABLES), headerHeight: 31, onSaveWithVariables: function (variables, code, cb) {
            onSaveWithVariables(variables, code, cb);
        }, 
        // TODO: REMOVE THIS CHECK WHEN REMOVING CODE EDITOR OUT OF STATIC NODE
        isCodeNode: true, isVoiceAgent: [3, 4].includes(domain.domain_type) }));
};
var EditorContainer = function (props) {
    return (react_1["default"].createElement(react_redux_1.Provider, { store: reduxStores_1["default"] },
        react_1["default"].createElement(CodeEditorContainer, __assign({}, props))));
};
exports["default"] = EditorContainer;
